export default "__VITE_ASSET__CQPx1jz3__"